import { GenericResponse } from "src/generated/adminapi";

export function isGeneric(arg: any): arg is GenericResponse {
  return arg.code !== undefined;
}

export function isString(arg: any): arg is string {
  return typeof arg === "string";
}
